/**
 * Map Configuration Constants
 *
 * Centralized constants for map configuration
 * following Clean Architecture principles
 */

export const MAP_CONFIG = {
  // Timeouts
  LOAD_TIMEOUT: 5000,
  MAX_RETRY_ATTEMPTS: 3,

  // Map Styles
  STYLES: {
    PRIMARY: 'mapbox://styles/mapbox/streets-v11',
    FALLBACK: 'mapbox://styles/mapbox/light-v10',
    OFFLINE: 'openstreetmap'
  },

  // Default Settings
  DEFAULT_CENTER: {
    lat: 24.7136, // Riyadh coordinates
    lng: 46.6753
  },
  DEFAULT_ZOOM: 10,
  MIN_ZOOM: 3,
  MAX_ZOOM: 20,

  // Cache Settings
  MAX_TILE_CACHE_SIZE: 50,
  FADE_DURATION: 0
} as const;

export const MAP_STYLE_STATES = {
  PRIMARY: 'primary',
  FALLBACK: 'fallback',
  OFFLINE: 'offline',
  COMPLETE_OFFLINE: 'complete-offline'
} as const;

export type MapStyleState = typeof MAP_STYLE_STATES[keyof typeof MAP_STYLE_STATES];
